import { ArrowLeftRight } from "lucide-react";
import { formatDate, formatMoney } from "../lib/format";
import { haptics } from "../lib/haptics";
import type { ExpenseOut } from "../lib/schemas";
import { Avatar } from "../ui";

interface Props {
  expense: ExpenseOut;
  currency: string;
  onClick: () => void;
}

// A transaction row designed to sit inside a rounded card: leading avatar (the
// payer) or a settlement glyph, a two-line primary/secondary stack, and the
// amount right-aligned on tabular figures.
export default function ExpenseRow({ expense, currency, onClick }: Props) {
  const isSettlement = expense.kind === "settlement";
  return (
    <button
      type="button"
      onClick={() => { haptics.tap(); onClick(); }}
      className="w-full text-left flex items-center gap-3 px-4 py-3.5 border-t border-hairline first:border-t-0 active:bg-surface-2 transition-colors"
    >
      {isSettlement ? (
        <span className="flex items-center justify-center w-10 h-10 rounded-full bg-surface-2 text-success shrink-0">
          <ArrowLeftRight size={18} />
        </span>
      ) : (
        <Avatar name={expense.payer.first_name} size="md" />
      )}
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2">
          <p className="text-fg font-medium truncate">{expense.description}</p>
          {expense.undoable && (
            <span className="text-[10px] text-muted border border-hairline rounded-md px-1 py-0.5 flex-shrink-0">
              ↶
            </span>
          )}
        </div>
        <p className="text-muted text-sm truncate">
          {isSettlement ? "Settlement" : expense.payer.first_name} · {formatDate(expense.created_at)}
        </p>
      </div>
      <p className={`flex-shrink-0 font-mono [font-variant-numeric:tabular-nums] font-semibold ${isSettlement ? "text-muted" : "text-fg"}`}>
        {formatMoney(expense.total, currency)}
      </p>
    </button>
  );
}
